import { IStore } from 'store/types';
import { IApiList, IEmployee } from 'types';

export const selectEmployees =
  () =>
  (state: IStore): IApiList<IEmployee> =>
    state?.collections?.employees;
export const selectReviewRequiredEmployeesTotal =
  () =>
  (state: IStore): number =>
    state?.collections?.employees?.requiresReviewTotal;
